export default "__VITE_ASSET__CW2MWtAo__"